import React from "react";
import { Wrapped } from "@components/Layouts";
import Dashboard from "@components/Dashboard";

export default function DashboardPage() {
  return (
    <React.Fragment>
      <Wrapped>
        <Dashboard />
        <p style={{ marginTop: "20px" }}>
          UKMPTLT:{" "}
          <a href="mailto:imperial.ukmptltstudy@nhs.net">
            imperial.ukmptltstudy@nhs.net
          </a>
        </p>
      </Wrapped>
    </React.Fragment>
  );
}
